import { QuestionMarkCircledIcon } from '@radix-ui/react-icons';
import { HELP_URLS } from 'classes/helpers/url.helper';
import { SuperAdminIcon } from 'components/common/custom-icon/shorthands';
import { SidebarNavigationTrigger } from 'components/main/sidebar/nav-trigger';
import { SessionEventsContext } from 'contexts/session-events.context';
import { SessionDialogMode } from 'enums/session.enums';
import { useIsPlatformConsoleUser } from 'hooks/useIsPlatformConsoleUser';
import { t } from 'i18next';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useIntercom } from 'react-use-intercom';
import { paths } from 'routes/paths';
import { useAuthStore } from 'stores/use-auth-store';
import useBpSummaryStore from 'stores/use-bp-summary-store';

export const SupportMenu = () => {
  const { showNewMessage } = useIntercom();

  const navigate = useNavigate();

  const current = useAuthStore((s) => s.current);
  const userRoleFeatureFlags = useAuthStore((s) => s.userRoleFeatureFlags);
  const isPlatformConsoleUser = useIsPlatformConsoleUser();

  const { showDialog } = useContext(SessionEventsContext);

  return (
    <SidebarNavigationTrigger
      icon={<QuestionMarkCircledIcon />}
      label="main.support"
      actions={[
        {
          invisible: !isPlatformConsoleUser,
          label: 'Platform Console',
          suffixIcon: <SuperAdminIcon />,
          onClick: () => navigate(paths.platformConsole.root),
        },
        {
          invisible: !userRoleFeatureFlags.isSuperAdmin,
          label: 'Live BP Summary',
          suffixIcon: <SuperAdminIcon />,
          onClick: () => useBpSummaryStore.getState().toggleOpen(),
        },
        {
          label: 'main.current-session',
          onClick: () => {
            showDialog({
              session: {
                sessionID: current.session,
                machineID: current.machineID,
              },
              mode: SessionDialogMode.edit,
              key: Date.now(),
            });
          },
        },
        {
          label: 'main.help-center',
          onClick: () =>
            window.open(t('common.intercom-url') + HELP_URLS.LANDING),
        },
        {
          label: 'common.trajekt-store',
          onClick: () => window.open('https://trajektsports.myshopify.com/'),
        },
        {
          label: 'common.contact-support',
          onClick: () => showNewMessage(),
        },
        {
          label: 'common.product-updates',
          onClick: () =>
            window.open(t('common.intercom-url') + HELP_URLS.PRODUCT_UPDATES),
        },
        {
          label: 'common.safety-policy',
          onClick: () => useAuthStore.getState().setShowSafetyPolicy(true),
        },
        {
          label: 'common.terms-of-use',
          onClick: () => useAuthStore.getState().setShowTermsOfUse(true),
        },
      ]}
      small
    />
  );
};
